import { SvgIcon, SvgIconProps } from "@mui/material";

export const SDFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m14 24.666-4.667-4.665V20h-3.5A2.333 2.333 0 0 1 3.5 17.666V6a2.333 2.333 0 0 1 2.333-2.333h16.334A2.333 2.333 0 0 1 24.5 6v11.666A2.333 2.333 0 0 1 22.167 20h-3.5L14 24.665"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m14 24.666-4.667-4.665V20h-3.5A2.333 2.333 0 0 1 3.5 17.666V6a2.333 2.333 0 0 1 2.333-2.333h16.334A2.333 2.333 0 0 1 24.5 6v11.666A2.333 2.333 0 0 1 22.167 20h-3.5L14 24.665"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.209 12.21a.292.292 0 1 1-.413.412.292.292 0 0 1 .413-.413M18.87 12.21a.292.292 0 1 1-.412.412.292.292 0 0 1 .413-.413M9.54 12.21a.292.292 0 1 1-.413.412.292.292 0 0 1 .413-.413"
      />
    </svg>
  </SvgIcon>
);
